{
  "payment.paymentMethod": {
    "APEXX_PAYMENT_CARD": "Luotto- tai debit-kortti"
  },
  "oneUpgrade": {
    "errors": {
      "tooFarToDepartureAndPointPaymentNotAllowed": {
        "heading": "Maksettavia korotuksia ei ole vielä saatavilla",
        "paragraph": "Matkustusluokankorotuksen voi ostaa aikaisintaan <b>30 päivää ennen lennon lähtöä</b>."
      }
    }
  }
}
